import { CONFIG } from '../../config/gameConfig';
import type { Drawable } from '../../types';

const TILE_WIDTH = 24;

export class Ground implements Drawable {
  private offset = 0;

  update(speed: number): void {
    this.offset = (this.offset + speed) % TILE_WIDTH;
  }

  reset(): void {
    this.offset = 0;
  }

  draw(ctx: CanvasRenderingContext2D, width: number = CONFIG.canvas.width): void {
    ctx.fillStyle = '#535353';
    const y = CONFIG.game.groundY;
    ctx.fillRect(0, y, width, 2);
    for (let i = -this.offset; i < width; i += TILE_WIDTH) {
      ctx.fillRect(i, y + 4, 2, 2);
      ctx.fillRect(i + 14, y + 6, 3, 2);
    }
  }
}
